import { useMemo } from 'react';

import { Badge } from '@/design-system/components/ui';

import { EventTriggerType, Trigger } from '../../domain';
import { AmbientVolumeType } from '../../types';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function AmbientTradeDetails({ trigger, triggerType }: Props) {
  const volumeType = trigger.context?.volumeType as AmbientVolumeType | undefined;

  const volumeTypeDisplay = useMemo(() => {
    if (!volumeType) return '-';

    const volumeTypeLabels: Record<AmbientVolumeType, string> = {
      [AmbientVolumeType.MakerVolume]: 'Maker Volume',
      [AmbientVolumeType.TakerVolume]: 'Taker Volume',
      [AmbientVolumeType.AllVolume]: 'All Volume',
    };

    const label = volumeTypeLabels[volumeType] || volumeType;
    return <Badge size="sm">{label}</Badge>;
  }, [volumeType]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Volume Type" value={volumeTypeDisplay} />
    </div>
  );
}
